/**
 * Terms of Use content for SEOGeeks AI Visibility.
 *
 * Drawn from the Ukrainian Civil Code (Chapter 53 — Service
 * Agreements), Law on Consumer Rights Protection, and Law on
 * Electronic Commerce. Counsel should review before launch.
 */

const SHARED = {
  contactEmail: "ai-visibility@seogeeks.com.ua",
  lastUpdated: "2026-05-18",
};

export const TERMS_CONTENT = {
  uk: {
    ...SHARED,
    title: "Умови використання",
    intro:
      "Ці Умови використання регулюють доступ до сервісу SEOGeeks AI Visibility " +
      "(далі — «Сервіс») та його використання. Створюючи обліковий запис або " +
      "використовуючи Сервіс, ви погоджуєтесь із цими Умовами.",
    sections: [
      {
        title: "1. Обліковий запис",
        body: [
          "ви зобов'язані надавати коректні дані при реєстрації;",
          "ви несете відповідальність за збереження конфіденційності доступу до акаунта;",
          "ви повинні негайно повідомити нас про підозрілу активність у вашому акаунті;",
          "один користувач реєструє один обліковий запис, якщо інше не погоджено окремо.",
        ],
      },
      {
        title: "2. Дозволене використання",
        body:
          "Користувач зобов'язується не використовувати Сервіс для незаконної діяльності, не " +
          "втручатися в роботу інфраструктури, не намагатися обійти обмеження безпеки, не " +
          "порушувати права інтелектуальної власності інших осіб та не використовувати " +
          "результати роботи Сервісу способами, що суперечать ліцензіям постачальників " +
          "LLM-моделей (OpenAI, Anthropic, Google та інших).",
      },
      {
        title: "3. Функціональність та зміни",
        body:
          "Ми можемо оновлювати, змінювати або обмежувати окремі функції Сервісу з метою " +
          "розвитку продукту, безпеки та стабільності. Про істотні зміни ми завчасно " +
          "повідомляємо у кабінеті або електронною поштою.",
      },
      {
        title: "4. Інтелектуальна власність",
        body:
          "Всі права на програмний код, дизайн, структуру та матеріали Сервісу належать " +
          "правовласнику SEOGeeks, крім випадків, коли інше прямо зазначено. Згенеровані " +
          "Сервісом артефакти (наприклад, llms.txt, звіти видимості) Користувач може вільно " +
          "використовувати для своїх сайтів та клієнтів.",
      },
      {
        title: "5. Відповідальність",
        body:
          "Сервіс надається «як є». Ми докладаємо розумних зусиль для безперервної роботи, " +
          "але не гарантуємо відсутність технічних збоїв чи повну безпомилковість. Точність " +
          "відповідей LLM-моделей залежить від зовнішніх постачальників API і може змінюватися " +
          "без попередження.",
      },
      {
        title: "6. Обмеження відповідальності",
        body:
          "У межах, дозволених законодавством, SEOGeeks не несе відповідальності за непрямі " +
          "збитки, втрату даних, прибутку чи ділової репутації, що виникли внаслідок використання " +
          "або неможливості використання Сервісу. Максимальна сума відповідальності обмежується " +
          "вартістю, сплаченою Користувачем за останній розрахунковий період.",
      },
      {
        title: "7. Припинення доступу",
        body:
          "Ми можемо тимчасово призупинити або припинити доступ Користувача у разі порушення " +
          "цих Умов, вимог безпеки або чинного законодавства. Користувач може у будь-який час " +
          "припинити користування Сервісом, видаливши свій обліковий запис у налаштуваннях.",
      },
      {
        title: "8. Застосовне право",
        body:
          "До цих Умов застосовується право України. Спори вирішуються шляхом переговорів, а у " +
          "разі недосягнення згоди — у судах за місцезнаходженням Виконавця.",
      },
      {
        title: "9. Контакти",
        body:
          "З питань щодо Умов використання звертайтесь: " + SHARED.contactEmail + ".",
      },
    ],
  },

  ru: {
    ...SHARED,
    title: "Условия использования",
    intro:
      "Настоящие Условия использования регулируют доступ к сервису SEOGeeks AI " +
      "Visibility (далее — «Сервис») и его использование. Создавая аккаунт или " +
      "используя Сервис, вы соглашаетесь с этими Условиями.",
    sections: [
      {
        title: "1. Аккаунт",
        body: [
          "вы обязаны предоставлять достоверные данные при регистрации;",
          "вы несёте ответственность за сохранение конфиденциальности доступа к аккаунту;",
          "вы должны немедленно сообщить нам о подозрительной активности в вашем аккаунте;",
          "один пользователь регистрирует один аккаунт, если иное не согласовано отдельно.",
        ],
      },
      {
        title: "2. Допустимое использование",
        body:
          "Пользователь обязуется не использовать Сервис для незаконной деятельности, не " +
          "вмешиваться в работу инфраструктуры, не пытаться обойти ограничения безопасности, " +
          "не нарушать права интеллектуальной собственности других лиц и не использовать " +
          "результаты работы Сервиса способами, противоречащими лицензиям поставщиков " +
          "LLM-моделей (OpenAI, Anthropic, Google и других).",
      },
      {
        title: "3. Функциональность и изменения",
        body:
          "Мы можем обновлять, изменять или ограничивать отдельные функции Сервиса в целях " +
          "развития продукта, безопасности и стабильности. О существенных изменениях мы " +
          "заранее уведомляем в кабинете или по email.",
      },
      {
        title: "4. Интеллектуальная собственность",
        body:
          "Все права на программный код, дизайн, структуру и материалы Сервиса принадлежат " +
          "правообладателю SEOGeeks, кроме случаев, когда явно указано иное. Артефакты, " +
          "сгенерированные Сервисом (например, llms.txt, отчёты видимости), Пользователь может " +
          "свободно использовать для своих сайтов и клиентов.",
      },
      {
        title: "5. Ответственность",
        body:
          "Сервис предоставляется «как есть». Мы прилагаем разумные усилия для непрерывной " +
          "работы, но не гарантируем отсутствие технических сбоев и полную безошибочность. " +
          "Точность ответов LLM-моделей зависит от внешних поставщиков API и может изменяться " +
          "без предварительного уведомления.",
      },
      {
        title: "6. Ограничение ответственности",
        body:
          "В пределах, разрешённых законодательством, SEOGeeks не несёт ответственности за " +
          "косвенные убытки, потерю данных, прибыли или деловой репутации, возникшие вследствие " +
          "использования или невозможности использования Сервиса. Максимальная сумма " +
          "ответственности ограничивается стоимостью, уплаченной Пользователем за последний " +
          "расчётный период.",
      },
      {
        title: "7. Прекращение доступа",
        body:
          "Мы можем временно приостановить или прекратить доступ Пользователя в случае " +
          "нарушения этих Условий, требований безопасности или действующего законодательства. " +
          "Пользователь может в любое время прекратить использование Сервиса, удалив свой " +
          "аккаунт в настройках.",
      },
      {
        title: "8. Применимое право",
        body:
          "К настоящим Условиям применяется право Украины. Споры разрешаются путём переговоров, " +
          "а при недостижении согласия — в судах по местонахождению Исполнителя.",
      },
      {
        title: "9. Контакты",
        body:
          "По вопросам Условий использования обращайтесь: " + SHARED.contactEmail + ".",
      },
    ],
  },

  en: {
    ...SHARED,
    title: "Terms of Use",
    intro:
      "These Terms of Use govern access to and use of SEOGeeks AI Visibility " +
      "(the “Service”). By creating an account or using the Service you agree " +
      "to these Terms.",
    sections: [
      {
        title: "1. Account",
        body: [
          "You must provide accurate data when registering;",
          "You are responsible for keeping your account credentials confidential;",
          "You must report any suspicious account activity to us immediately;",
          "One user registers one account unless otherwise agreed separately.",
        ],
      },
      {
        title: "2. Permitted use",
        body:
          "You agree not to use the Service for unlawful activity, not to interfere with " +
          "the infrastructure, not to attempt to bypass security controls, not to infringe " +
          "third-party intellectual property, and not to use Service outputs in ways that " +
          "violate the licences of LLM providers (OpenAI, Anthropic, Google and others).",
      },
      {
        title: "3. Functionality and changes",
        body:
          "We may update, modify or restrict specific Service features for product " +
          "development, security, and stability. Material changes are announced in-app or " +
          "by email in advance.",
      },
      {
        title: "4. Intellectual property",
        body:
          "All rights to the source code, design, structure, and materials of the Service " +
          "belong to SEOGeeks unless explicitly stated otherwise. Artifacts the Service " +
          "generates for you (e.g. llms.txt, visibility reports) may be used freely for your " +
          "own sites and clients.",
      },
      {
        title: "5. Liability",
        body:
          "The Service is provided “as is”. We make reasonable efforts to keep it running " +
          "continuously but do not guarantee freedom from technical failure or complete " +
          "accuracy. The accuracy of LLM responses depends on third-party API providers and " +
          "may change without notice.",
      },
      {
        title: "6. Limitation of liability",
        body:
          "To the extent permitted by law, SEOGeeks is not liable for indirect damages, loss " +
          "of data, profits or business reputation arising from use or inability to use the " +
          "Service. Maximum liability is capped at the amount paid by the user for the last " +
          "billing period.",
      },
      {
        title: "7. Termination",
        body:
          "We may temporarily suspend or terminate user access for breach of these Terms, " +
          "security violations or applicable law. You may stop using the Service at any time " +
          "by deleting your account in settings.",
      },
      {
        title: "8. Governing law",
        body:
          "These Terms are governed by the law of Ukraine. Disputes are resolved by " +
          "negotiation, and failing agreement, by the courts at the Operator's seat.",
      },
      {
        title: "9. Contact",
        body:
          "For questions about these Terms, contact: " + SHARED.contactEmail + ".",
      },
    ],
  },
};
